"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.individualPriceOfPeriodForQuantity = void 0;
const individualPriceOfPeriodForQuantity = (byQuantity, quantity, periodName) => {
    const startingToKey = Object.keys(byQuantity)
        .map(Number)
        .sort((a, b) => b - a)
        .find((quantityStartingTo) => quantity >= quantityStartingTo);
    const matchingPrice = byQuantity[startingToKey || 1];
    if (matchingPrice && matchingPrice[periodName]) {
        return Number(matchingPrice[periodName]);
    }
    const anyPeriodName = Object.keys(matchingPrice)[0];
    return Number(matchingPrice[anyPeriodName]);
};
exports.individualPriceOfPeriodForQuantity = individualPriceOfPeriodForQuantity;
//# sourceMappingURL=individualPriceOfPeriodForQuantity.js.map